<template>
  <div class="bg" v-if="canEdit">
    <!-- 搜索栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="queryStr" :placeholder="$t('message.signatureInsertOrderSearchPlaceholder')"></el-input>
        </div>
        <div class="search_btn" @click="searchAvailableorder">{{$t('message.searchBtnText')}}</div>
      </div>
      <div class="add_btn" @click="addInsertOrder">{{$t('message.signatureInsertOrderText')}}</div>
    </div>
    <!-- 搜索栏 -->
    <!-- 列表 -->
    <div class="content">
      <div class="tableBox">
         <el-table id="enableOrderList" :data="enableOrderList" style="width: 100%" ref="multipleTable" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @selection-change="orderSelectionChange" @sort-change="sortChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle1')" prop="ORDERNUM" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle10')" prop="status" width="100"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle4')" prop="JJGS" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.addresseeCompanyTitle')" prop="SJGS" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.signatureAddTimeTitle')" prop="addTime" min-width="150" sortable="custom"></el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <!-- 列表 -->
  </div>
  <div class="bg" v-else>
    <!-- 签收单管理列表 -->
    <div class="content">
      <el-table id="signOrderList" :data="signOrderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%">
        <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="130"></el-table-column>
        <el-table-column :label="$t('message.orderTableTitle1')" prop="ORDERNUM" min-width="130"></el-table-column>
        <el-table-column :label="$t('message.orderTableTitle10')" prop="status" min-width="100"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="sign_sizeChange"
        @current-change="sign_currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <!-- 签收单管理列表 -->
  </div>
</template>

<script>
  import { getAvailableOrder, setSignOrders, getSignOrders } from '@/api/getData.js'
  export default {
    name: 'signatureFormOrders',
    data () {
      return {
        page_no: 1,
        page_size: 20,
        pageSizes: [20, 50, 100, 200, 500],
        totalSize: 0,
        orderNum: '',
        queryStr: '',
        enableOrderList: [],
        newSignOrderSel: [],
        canEdit: false,
        pid: '',
        signOrderList: [],
        prop: null,
        order: ''
      }
    },
    created() {
      let query = this.$route.query
      if (query.hasOrder === 0) {
        // 查询可用订单列表
        this.canEdit = true
        this.pid = query.GUID
        this.getAvailableOrder()
      } else {
        // 查询签约单订单列表
        this.canEdit = false
        this.pid = query.GUID
        this.getSignOrders()
      }
    },
    methods: {
      // 获取可用订单列表
      async getAvailableOrder (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
        if (this.prop) {
          param.ORDERNAME = this.prop
        }
        param.DOA = this.order
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        param.ADDUSERID = this.$store.state.JHSS.personalUserid
        let res = await getAvailableOrder(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data.dt)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        let orderState2 = this.$t('message.orderState2')
        let orderState1 = this.$t('message.orderState1')
        this.enableOrderList = res.data.dt.map(item => {
          item.index = ++index
          item.status = item.STATE === '2' ? orderState2 : orderState1
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          return item
        })
        this.newSignOrderSel = []
      },
      // 搜索可用订单
      searchAvailableorder () {
        this.page_no = 1
        this.searchFun()
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      searchFun () {
        let param = {}
        // 查询客户管理
        if (this.queryStr) {
          param.QueryStr = this.queryStr
        }
        this.getAvailableOrder(param)
      },
      orderSelectionChange (val) {
        // console.log(val)
        this.newSignOrderSel = val
      },
      // 查询签收单订单
      async getSignOrders () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = {}
        param.PID = this.pid
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getSignOrders(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data.dt)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        let orderState2 = this.$t('message.orderState2')
        let orderState1 = this.$t('message.orderState1')
        this.signOrderList = res.data.dt.map(item => {
          item.index = ++index
          item.status = item.STATE === '2' ? orderState2 : orderState1
          return item
        })
      },
      sign_sizeChange (val) {
        this.page_size = val
        this.page_no = 1
        this.getSignOrders()
      },
      sign_currentChange (val) {
        this.page_no = val
        this.getSignOrders()
      },
      // 插入订单
      addInsertOrder () {
        if (this.newSignOrderSel.length === 0) {
          this.$message.error(this.$t('message.signatureInsertTipsText'))
        } else {
          this.$confirm(this.$t('message.signatureInsertPrompt'), this.$t('message.promptTitle'), {
            confirmButtonText: this.$t('message.confirmText'),
            cancelButtonText: this.$t('message.cancleText')
          }).then(() => {
            this.setSignOrders()
          }).catch(() => {
            this.$message(this.$t('message.canclePrompt'));
          });
        }
      },
      // 确定插入订单
      async setSignOrders () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = []
        let newSignOrderSel = this.newSignOrderSel
        for (let i = 0; i < newSignOrderSel.length; i++) {
          let obj = { PID: this.pid, ORDERNUM: newSignOrderSel[i].ORDERNUM }
          param.push(obj)
        }
        let res = await setSignOrders(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.page_no = 1
          this.canEdit = false
          this.getSignOrders()
        }
      },
      // 时间排序
      sortChange (obj) {
        // console.log(obj)
        // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
        this.prop = null
        if (obj.prop === 'addTime') {
          this.prop = 'ADDTIME'
          // param.ORDERNAME = 'ADDTIME'
        }
        this.order = ''
        if (obj.order === 'descending') {
          this.order = 'DESC'
          // param.DOA = 'DESC'
        }
        this.page_no = 1
        this.searchFun()
      }
    }
  }
</script>

<style scoped>
</style>
